import { useEffect, useState, useRef } from "react";
import "../App.css";

export default function Impact() {
  const [stories, setStories] = useState([]);
  const [current, setCurrent] = useState(0);
  const [expanded, setExpanded] = useState(null);

  const [childCount, setChildCount] = useState(0);
  const [amountRaised, setAmountRaised] = useState(0);
  const [animated, setAnimated] = useState(false); // prevent multiple triggers
  const impactRef = useRef(null);

  // Fetch stories
  useEffect(() => {
    fetch("/Stories.txt")
      .then((res) => res.text())
      .then((text) => {
        const parsed = text
          .split(/\n\s*\n/)
          .map((block) => {
            const parts = block.split("||");
            if (parts.length < 2) return null;
            return {
              name: parts[0].trim(),
              text: parts.slice(1).join("||").trim(),
            };
          })
          .filter(Boolean);
        setStories(parsed);
      })
      .catch(console.error);
  }, []);

  // Auto story slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % stories.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [stories]);

  // Count animation triggered on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (!impactRef.current || animated) return;
      const rect = impactRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top <= windowHeight * 0.75) { // trigger when 75% visible
        setAnimated(true);

        const childTarget = 500;     // final children count
        const amountTarget = 1000000; // 10L in INR
        const duration = 3000;       // 3 seconds
        const frameRate = 60;        // 60 frames per second

        const totalFrames = Math.round((duration / 1000) * frameRate);
        let frame = 0;

        const childIncrement = childTarget / totalFrames;
        const amountIncrement = amountTarget / totalFrames;

        const interval = setInterval(() => {
          frame++;
          setChildCount(Math.min(Math.round(frame * childIncrement), childTarget));
          setAmountRaised(Math.min(Math.round(frame * amountIncrement), amountTarget));
          if (frame >= totalFrames) clearInterval(interval);
        }, duration / totalFrames);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [animated]);

  if (stories.length < 3) {
    return (
      <section id="impact" className="impact-section" ref={impactRef}>
        <p style={{ textAlign: "center" }}>Loading stories...</p>
      </section>
    );
  }

  const getIndex = (offset) => (current + offset + stories.length) % stories.length;

  return (
    <section id="impact" className="impact-section" ref={impactRef}>
      <h2 className="home-text">OUR CHILDREN'S SUCCESS STORIES</h2>

      {/* Animated Impact Stats */}
      <div className="impact-stats">
        <div className="impact-card">
          <h3>{childCount}+ Children</h3>
          <p>Supported</p>
        </div>
        <div className="impact-card">
          <h3>₹{(amountRaised / 100000).toFixed(1)}L+</h3>
          <p>Raised</p>
        </div>
      </div>

      {/* Story Lane */}
      <div className="story-lane">
        {[ -1, 0, 1 ].map((offset) => {
          const idx = getIndex(offset);
          const story = stories[idx];
          const isCenter = offset === 0;
          const isExpanded = expanded === idx;

          return (
            <div
              key={idx}
              className={`story-card ${isCenter ? "center" : "side"} ${isExpanded ? "expanded" : ""}`}
            >
              <h4>{story.name}</h4>
              <p className={!isExpanded ? "clamp" : ""}>{story.text}</p>

              {story.text.length > 250 && !isExpanded && (
                <span className="read-more" onClick={() => setExpanded(idx)}>
                  Read more
                </span>
              )}
              {isExpanded && (
                <span className="read-more" onClick={() => setExpanded(null)}>
                  Collapse
                </span>
              )}
            </div>
          );
        })}
      </div>

      <button
        className="impactslider-btn left"
        onClick={() => setCurrent((c) => (c - 1 + stories.length) % stories.length)}
      >
        &#10094;
      </button>
      <button
        className="impactslider-btn right"
        onClick={() => setCurrent((c) => (c + 1) % stories.length)}
      >
        &#10095;
      </button>
    </section>
  );
}
